// src/config.ts
import logoDefault from "@assets/img/logo/logo-symbol.svg";
import logoCES from "@assets/img/logo-partners/logo-symbol-cannabisesaude.svg";
import logoTegraPharma from "@assets/img/logo-partners/logo-symbol-tegrapharma.svg";
import logoTegraPharmaCorp from "@assets/img/logo-partners/logo-symbol-tegrapharmacorp.svg";
import logoVigo from "@assets/img/logo-partners/logo-symbol-vigo.svg";
import logoCanteraMed from "@assets/img/logo-partners/logo-symbol-canteramed.svg";
import logoOdontoCanSummit from "@assets/img/logo-partners/logo-symbol-odontocansummit.svg";

const production = true;

export const config = {
  // --- Connection Configs --- //
  production,
  apiUrl: production ? "https://api-panel.tegrapharma.com" : "http://localhost:3333",

  // --- System Configs --- //
  appName: `OnixCann`,
  appAgent: `onixcann`,

  // --- Images --- //
  logos: {
    default: logoDefault,
    ces: logoCES,
    vigo: logoVigo,
    tegra: logoTegraPharma,
    tegracorp: logoTegraPharmaCorp,
    canteramed: logoCanteraMed,
    odontocansummit: logoOdontoCanSummit,
  },
};
